import React from 'react';
import Gravatar from './Gravatar';
import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';


function GravatarAndName(props) {

  const {
    email = '',
    name = '',
    label,
    useBlank = false,
    defaultImage,
    avatarClassName = '',
    typographyClassName = '',
    typographyComponent,
    typographyVariant = 'body1',
    useMarginBottom
  } = props;

  return (
    <div style={{display: 'flex', alignItems: 'center', paddingLeft: !label ? '0.5rem' : undefined, 
    marginBottom: useMarginBottom}}>
      {label && (
        <Typography style={{marginRight: 6}} variant={typographyVariant} className={typographyClassName}
                    component={typographyComponent}>
          {label}
        </Typography>
      )}
      <Gravatar name={name} email={email} useBlank={useBlank} defaultImage={defaultImage}
                className={avatarClassName}/>
      <Typography style={{marginLeft: 6, marginRight: 6, maxWidth: '11rem'}}
                  variant={typographyVariant} className={typographyClassName}
                  component={typographyComponent}>
        {name}
      </Typography>
    </div>
  );
}

GravatarAndName.propTypes = {
  email: PropTypes.string,
  name: PropTypes.string,
  defaultImage: PropTypes.string,
  avatarClassName: PropTypes.string,
  typographyClassName: PropTypes.string,
  typographyComponent: PropTypes.string,
  typographyVariant: PropTypes.string,
  useBlank: PropTypes.bool,
};

export default GravatarAndName;
